import axios from "axios";

export const GET_REGLAS_AUTORIZADAS_LIST    = "GET_REGLAS_AUTORIZADAS_LIST";

export const getReglasAutorizadasList = () => {

    return (dispatch) => {
        //console.log("Javier -------> Se carga ACTION | getReglasAutorizadasList");
        axios
            .get("/api/ReporteAdministrativo/ObtieneReglasAutorizadas")
            .then(function (response) {
                //console.log(response.data);
                dispatch({
                    type: GET_REGLAS_AUTORIZADAS_LIST,
                    payload: {
                        data: response.data,
                        errorMessage: false,
                    },
                });

            })
            .catch(function (error) {
                dispatch({
                    type: GET_REGLAS_AUTORIZADAS_LIST,
                    payload: {
                        data: false,
                        errorMessage: error.message,
                    },
                });
            });
    };
};

